import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { setPOSDiscountCodes } from "../../../../../modules/order/order.actions";
import { posDiscountCodesSelector } from "../../../../../modules/order/order.reducers";
import { useAppCtx } from "../../../../../providers/app.provider";
import posCartService from "../../../../../services/pos/pos-cart.services";
import reduxService from "../../../../../services/redux.services";
import { formatTextCurrency } from "../../../../../utils/helpers";
import { HttpStatusCode } from "../../../../../utils/http-common";
import {
  CheckCircleIcon,
  DiscountCodeIcon,
  DiscountPercentIcon,
  RemoveDiscountCodeIcon,
  WarningTriangle,
} from "../../../../assets/icons.constants";
import NameAndValuePopover from "../../../../components/name-and-value-popup/NameAndValuePopover";
import "./SummaryOrder.scss";

function SummaryOrder(props) {
  const { data, setIsLoading, orderId, fetchDataOrdered } = props;
  const [t] = useTranslation();
  const discountCodes = useSelector(posDiscountCodesSelector);
  const { Toast } = useAppCtx();

  const pageData = {
    summary: t("checkOutPage.summary", "Summary"),
    subTotal: t("checkOutPage.subTotal", "Subtotal"),
    discount: t("checkOutPage.discount", "Discount"),
    feeAndTax: t("checkOutPage.feeAndTax", "Fee & Tax"),
    total: t("checkOutPage.total", "Total"),
    rank: t("myProfile.myOrders.rank", "Rank"),
    tax: t("checkOutPage.tax", "Tax"),
  };

  const { totalFee = 0, totalTax = 0, originalPrice = 0, totalDiscountAmount = 0, totalAmount = 0 } = data;

  const totalFeeAndTax = totalFee + totalTax;

  function handleRemoveDiscountCode(code) {
    let POSDiscountCodes = reduxService.getPOSDiscountCodes();
    const indexExist = POSDiscountCodes?.findIndex((discountCode) => discountCode === code);
    if (indexExist !== -1) {
      POSDiscountCodes.splice(indexExist, 1);
      applyDiscountCodes(POSDiscountCodes);
    }
  }

  async function applyDiscountCodes(discountCodes) {
    setIsLoading(true);
    const request = {
      orderId: orderId,
      discountCodes: discountCodes ?? [],
    };
    const response = await posCartService.applyDiscountCodesToOrderAsync(request);
    setIsLoading(false);
    const { succeeded, message, data } = response?.data;
    if (response?.status === HttpStatusCode.Ok) {
      const discountCodesApplied = data?.discountCodes ?? [];
      reduxService.dispatch(setPOSDiscountCodes(discountCodesApplied));
      fetchDataOrdered(orderId);
      if (succeeded) {
        Toast.show({
          messageType: "success",
          message: t("messages.appliedDiscountCodeSuccessfully", "Áp dụng mã giảm giá thành công"),
          icon: <CheckCircleIcon />,
          placement: "top",
          duration: 3,
        });
      } else {
        Toast.show({
          messageType: "warning",
          message: t(message),
          icon: <WarningTriangle />,
          placement: "top",
          duration: 3,
        });
      }
    } else {
      Toast.show({
        messageType: "warning",
        message: t(message),
        icon: <WarningTriangle />,
        placement: "top",
        duration: 3,
      });
    }
  }

  function renderDiscountCodeTag(discountCode, isPopover = false) {
    return (
      <div className="discount-code-tag">
        <span className="discount-code-background"></span>
        <span className="line-dashed"></span>
        <div className="prefix">
          {isPopover ? <DiscountPercentIcon /> : <DiscountCodeIcon />}
        </div>
        <div className="title-discount-code">{discountCode}</div>
        {!isPopover && (
          <div className="remove-icon" onClick={() => handleRemoveDiscountCode(discountCode)}>
            <RemoveDiscountCodeIcon />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="pos-checkout-summary pos-checkout-summary-order">
      <div className="title">{pageData.summary}</div>
      <div className="content">
        <div className="line">
          <div span={16}>{pageData.subTotal}</div>
          <div span={8}>{formatTextCurrency(originalPrice)}</div>
        </div>
        <div className="line">
          <div span={16} className="discount">
            {pageData.discount}
            {totalDiscountAmount > 0 && (
              <div className="show-detail-icon">
                <NameAndValuePopover
                  className="discount-popover discount-popover-summary-order discount__detail"
                  data={posCartService.mappingOrderDetailToPromotionPopupData(data, renderDiscountCodeTag)}
                  placement={"bottomLeft"}
                />
              </div>
            )}
          </div>
          <div span={8}>{formatTextCurrency(-totalDiscountAmount)}</div>
        </div>
        {discountCodes?.map((discountCode) => renderDiscountCodeTag(discountCode))}
        <div className="line">
          <div span={16}>
            {pageData.feeAndTax}
            {totalFeeAndTax > 0 && (
              <div className="show-detail-icon">
                <NameAndValuePopover
                  className="fee-and-tax-popover fee-and-tax-popover-summary-order"
                  placement={"bottomLeft"}
                  data={posCartService.mappingOrderDetailToFeeAndTaxPopupData(data)}
                />
              </div>
            )}
          </div>
          <div span={8}>{formatTextCurrency(totalFeeAndTax)}</div>
        </div>
      </div>
      <div className="total">
        <div className="line">
          <div span={16}> {pageData.total}</div>
          <div span={8}>{formatTextCurrency(totalAmount)}</div>
        </div>
      </div>
    </div>
  );
}

export default SummaryOrder;
